import axios from 'axios'

export const NavigationApi = {
  async Track(data) {
    const response = await axios.post('/api/navigation/track', data)
    return response
  },
  async ScreenStats(data) {
    const response = await axios.post('/api/navigation/report/screens', data)
    return response
  },
  async UserActivity(data) {
    const response = await axios.post('/api/navigation/report/users', data)
    return response
  },
  async Flow(data) {
    const response = await axios.post('/api/navigation/report/flow', data)
    return response
  },
  async UserTimeline(data) {
    const response = await axios.post('/api/navigation/report/user-timeline', data)
    return response
  },
}
